import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/redux';
import { isDEV } from '@/utils/Location';

let accessExpiresAt: string | number | null =
  localStorage.getItem('accessExpiresAt');

let refreshExpiresAt: string | number | null =
  localStorage.getItem('refreshExpiresAt');

accessExpiresAt = (accessExpiresAt && +accessExpiresAt) || null;
refreshExpiresAt = (refreshExpiresAt && +refreshExpiresAt) || null;

const mcdApplication = (window as Application).mcd ?? isDEV();

const refreshToken = localStorage.getItem('refreshToken');
const accessToken = localStorage.getItem('accessToken');

export const state = mcdApplication
  ? {
      refreshExpiresAt: null,
      accessExpiresAt: null,
      refreshToken: null,
      accessToken: null
    }
  : {
      refreshExpiresAt,
      accessExpiresAt,
      refreshToken,
      accessToken
    };

type AuthState = {
  refreshExpiresAt: number | null;
  accessExpiresAt: number | null;
  refreshToken: string | null;
  accessToken: string | null;
};

export const {
  reducer,
  actions: { setAuthData }
} = createSlice({
  initialState: state,
  name: 'auth',
  reducers: {
    setAuthData: (_, action: PayloadAction<AuthState>) => {
      const { refreshExpiresAt, accessExpiresAt, refreshToken, accessToken } =
        action.payload;

      refreshExpiresAt
        ? localStorage.setItem('refreshExpiresAt', refreshExpiresAt.toString())
        : localStorage.removeItem('refreshExpiresAt');

      accessExpiresAt
        ? localStorage.setItem('accessExpiresAt', accessExpiresAt.toString())
        : localStorage.removeItem('accessExpiresAt');

      refreshToken
        ? localStorage.setItem('refreshToken', refreshToken)
        : localStorage.removeItem('refreshToken');

      accessToken
        ? localStorage.setItem('accessToken', accessToken)
        : localStorage.removeItem('accessToken');

      return action.payload;
    }
  }
});

export const getRefreshToken = (state: RootState) => state.auth.refreshToken;
export const getAccessToken = (state: RootState) => state.auth.accessToken;
export const getLogged = (state: RootState) => !!state.auth.accessToken;

export const getRefreshExpiration = (state: RootState) =>
  state.auth.refreshExpiresAt;

export const getAccessExpiration = (state: RootState) =>
  state.auth.accessExpiresAt;
